export const DEFAULT_DESIGN_PRINT_TYPE_ID = 1;

export const isValidDesignPrintingMethod = (value: unknown): value is number => typeof value === 'number' && Number.isSafeInteger(value) && value > 0;

export const resolveComposerDesignPrintingMethod = (current: unknown): number =>
    isValidDesignPrintingMethod(current) ? current : DEFAULT_DESIGN_PRINT_TYPE_ID;

/** Supply the template's base method without adding a product assignment or changing scene actions. */
export const initializeComposerDesignPrintingMethod = (design: MPlaza.Design): void => {
    const printTypeID = resolveComposerDesignPrintingMethod(design.get('printTypeID'));
    if (design.get('printTypeID') !== printTypeID) design.set('printTypeID', printTypeID);
};
